import { ErinnerungsZeiten } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/erinnerungsZeiten';
import { Abteilungsleiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abteilungsleiter';
import { ArbeitsbereichOption } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitsbereichOption';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { useTranslation } from 'react-i18next';
import z from 'zod';

export function useCreateAndUpdateSchema() {
  const { t } = useTranslation();

  const schema = z
    .object({
      standort: z.instanceof(Standort, {
        message: t('generalValidationError.required'),
      }),
      arbeitsbereich: z.instanceof(ArbeitsbereichOption, {
        message: t('generalValidationError.required'),
      }),
      abteilungsleiter: z.instanceof(Abteilungsleiter).optional(),
      von: z.date({
        message: t('generalValidationError.required'),
      }),
      bis: z.date({
        message: t('generalValidationError.required'),
      }),
      lernziele: z
        .string()
        .max(400, {
          message: t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.lernziele.tooLong',
          ),
        })
        .optional(),
      fristErinnerung: z.boolean(),
      erinnerungsZeit: z
        .string()
        .array()
        .refine((value) => {
          return value.every((v) => Object.keys(ErinnerungsZeiten).includes(v));
        }),
      erinnerungAn: z.string().array(),
    })
    .superRefine((data, ctx) => {
      if (data.fristErinnerung) {
        if (data.erinnerungsZeit.length === 0) {
          ctx.addIssue({
            code: 'custom',
            message: t(
              'domain.mitarbeiter.fristen.erinnerungsZeit.validationError',
            ),
            path: ['erinnerungsZeit'],
          });
        }
        if (data.erinnerungAn.length === 0) {
          ctx.addIssue({
            code: 'custom',
            message: t(
              'domain.mitarbeiter.fristen.erinnerungsZeit.validationError',
            ),
            path: ['erinnerungAn'],
          });
        }
      }
    });

  return schema;
}
